export const rulesBundleName = 'bundle-experimental.tar.gz';
